import { render, staticRenderFns } from "./SuperchatSettings.vue?vue&type=template&id=6be3ff66"
import script from "./SuperchatSettings.vue?vue&type=script&lang=js"
export * from "./SuperchatSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports